import client from './client';

const getSubsidiaries = () =>
	client.get('/subsidiary/dashboard/users/subsidiaries');

export default { getSubsidiaries };
